import { useEffect } from 'react';

export function useListenToCombinrMessages(action, onMessage) {
    useEffect(() => {
        function onMessageReceived(e) {
            if (
                !e.data ||
                e.data.combinr !== true ||
                e.data.action !== action
            ) {
                return;
            }

            onMessage(e.data);
        }

        window.addEventListener('message', onMessageReceived);

        return () => {
            window.removeEventListener('message', onMessageReceived);
        };
    }, []);
}
